import { FREESTAR_ENABLED } from 'src/common/constants/experiments/ads';
import { useBreakpoint } from 'src/common/hooks/useBreakpoint';
import useExperiment from 'src/common/hooks/useExperiment';
import { useRouteProps } from 'src/common/providers/RoutePropsProvider';
import cssVariables from 'src/common/styles/variables';
import { getDisplayAdAttributes, gptSlotNames } from 'src/common/utils/ads/config';
import { useDetermineAdEligibility } from 'src/common/utils/ads/determineAdEligibility';
import { isDiscordMode } from 'src/common/utils/discord';
import DisplayAd from '../ads/DisplayAd';
import { OutstreamVideoAdSelector } from '../ads/OutstreamVideoAdSelector';
import showProfileAdInContentArea from '../profile/utils/showProfileAdInContentArea';
import UpsellRightSidebar from '../subscription/UpsellRightSidebar';

const isNever = () => false;

export function useCanShowProfilePageAds(isProfilePage: boolean) {
  /**
   * False until the client has measured the viewport. Otherwise the server's guess could render these ads, and
   * UpsellRightSidebar would report a view here and then again in RightSide. Other pages select a constant, so
   * crossing these widths doesn't re-render their content.
   */
  const isProfileAdBreakpoint = useBreakpoint(
    isProfilePage ? showProfileAdInContentArea : isNever,
    false,
  );
  const { guideId } = useRouteProps().guideContext;
  const canShowAds = useDetermineAdEligibility(guideId);

  return !isDiscordMode() && isProfileAdBreakpoint && Boolean(canShowAds);
}

export function ProfilePageAds() {
  const { guideContext, matchUrl } = useRouteProps();
  const { guideId } = guideContext;
  const isFreestarEnabled = useExperiment(FREESTAR_ENABLED);

  return (
    <>
      <OutstreamVideoAdSelector id="outstream-video-ad-profile-inline-right-side" />
      <DisplayAd
        style={{
          float: 'right',
          paddingLeft: cssVariables['--extra-margin'],
          paddingBottom: '25px',
        }}
        guideId={guideId}
        matchUrl={matchUrl}
        isProfile
        {...getDisplayAdAttributes(gptSlotNames.profile_side, isFreestarEnabled)}
      />
      {/* important: the key prop allows the component to remount and log upsell activity on pathname change */}
      <UpsellRightSidebar key={location.pathname} guideId={guideId} isProfile />
    </>
  );
}
